// function hideAltliWithoutHiddenInput() {
//     // Select all .product-grid-options-color elements
//     const colorOptions = document.querySelectorAll('.product-grid-options-color');
  
//     colorOptions.forEach(option => {
//       // Select all .altli elements within the .product-grid-options-color
//       const altliElements = option.querySelectorAll('.altli');
  
//       altliElements.forEach(altli => {
//         // Check if there's an input of type="hidden" with a value within .altli
//         const hiddenInput = altli.querySelector('input[type="hidden"][value]');
        
//         // If no such input is found, hide the .altli element
//         if (!hiddenInput) {
//           altli.style.display = 'none';
//         }
//       });
//     });
//   }
  
//   // Call the function to apply the changes
//   hideAltliWithoutHiddenInput();
  
//   document.querySelectorAll('.product-grid-options-size .altli').forEach(div => {
//     // Check if the div does NOT have both "is-selected" and "ava" classes
//     if (!div.classList.contains('is-selected')) {
//       // Hide the div if it doesn't have both classes
//       div.style.display = 'none';
//     }
//   });
  
//     const parentDiv = document.querySelector('.product-group-variants');


// function updateSelectedSize(event) {
//     // Get the clicked radio button (color) and its parent .product-group-variants
//     const selectedColor = event.target;
//     const productGroupVariants = selectedColor.closest('.product-group-variants');

//     if (!productGroupVariants) {
//         console.error("No parent .product-group-variants found.");
//         return;
//     }

//     const selectedColorValue = selectedColor.value;

//     // Find the .product-grid-options-size within the same .product-group-variants
//     const sizeOptionsContainer = productGroupVariants.querySelector('.product-grid-options-size');

//     if (!sizeOptionsContainer) {
//         console.error("No size options container found within the same parent.");
//         return;
//     }

//     // Iterate through the size options to find a matching size-val
//     const sizeVals = sizeOptionsContainer.querySelectorAll('.size-val');
//     let matchFound = false;

//     sizeVals.forEach((sizeVal) => {
//         const parentDiv = sizeVal.closest('.altli'); // Parent .altli
//         if (parentDiv) {
//             if (sizeVal.id === selectedColorValue) {
//                 // Add the new class to the parent div if it matches
//                 parentDiv.classList.add('is-selected');
//                 parentDiv.classList.add('new');
//                 parentDiv.style.display = 'block';
//                 matchFound = true;
//             } else {
//                 // Remove the class if it doesn't match
//                 parentDiv.classList.remove('is-selected');
//                 parentDiv.classList.remove('new');
//                 parentDiv.style.display = 'none';
//             }
//         }
//     });

//     if (!matchFound) {
//         console.warn(`No matching size found for the selected color: ${selectedColorValue}`);
//     }
// }

// // Attach event listeners to color radio buttons for each .product-group-variants
// document.querySelectorAll('.product-group-variants').forEach((productGroup) => {
//     const colorRadios = productGroup.querySelectorAll('.product-grid-options-color input[type="radio"]');
//     colorRadios.forEach((radio) => {
//         radio.addEventListener('change', updateSelectedSize);
//     });
// });

// // Initial state update for all .product-group-variants
// document.querySelectorAll('.product-group-variants').forEach((productGroup) => {
//     const selectedRadio = productGroup.querySelector('.product-grid-options-color input[type="radio"]:checked');
//     if (selectedRadio) {
//         updateSelectedSize({ target: selectedRadio });
//     }
// });


// function removeDuplicateSizes() {
//   // Select all `product-grid-options-size` containers
//   const sizeContainers = document.querySelectorAll('.product-grid-options-size');

//   sizeContainers.forEach((sizeContainer) => {
//       // Step 1: Get all `altli` divs inside the container
//       const altliDivs = sizeContainer.querySelectorAll('.altli');

//       // Step 2: Use a Map to track unique values
//       const sizeMap = new Map();

//       altliDivs.forEach((altli) => {
//           const sizeValDiv = altli.querySelector('.size-val');
          
//           if (sizeValDiv) {
//               const sizeValue = sizeValDiv.textContent.trim(); // Get the value of the size

//               if (sizeMap.has(sizeValue)) {
//                   // If the size value already exists, hide this duplicate
//                   altli.style.display = 'none';
//               } else {
//                   // If the size value is unique, add it to the map
//                   sizeMap.set(sizeValue, altli);
//                   altli.style.display = 'block'; // Ensure the unique size is displayed
//               }
//           }
//       });
//   });
// }

// // Call the function to remove duplicate sizes
// removeDuplicateSizes();


// document.addEventListener("DOMContentLoaded", function() {
//     var endlessScroll = new Ajaxinate({
//       container: '#Huratips-Loop',
//       pagination: '#Huratips-Pagination',
//      callback: function() {
//                hideAltliWithoutHiddenInput();
//                 document.querySelectorAll('.product-grid-options-size .altli').forEach(div => {
//                   // Check if the div does NOT have both "is-selected" and "ava" classes
//                   if (!div.classList.contains('is-selected')) {
//                     // Hide the div if it doesn't have both classes
//                     div.style.display = 'none';
//                   }
//                 });
//                   const parentDiv = document.querySelector('.product-group-variants');

// // Attach event listeners to color radio buttons for each .product-group-variants
// document.querySelectorAll('.product-group-variants').forEach((productGroup) => {
//     const colorRadios = productGroup.querySelectorAll('.product-grid-options-color input[type="radio"]');
//     colorRadios.forEach((radio) => {
//         radio.addEventListener('change', updateSelectedSize);
//     });
// });

// // Initial state update for all .product-group-variants
// document.querySelectorAll('.product-group-variants').forEach((productGroup) => {
//     const selectedRadio = productGroup.querySelector('.product-grid-options-color input[type="radio"]:checked');
//     if (selectedRadio) {
//         updateSelectedSize({ target: selectedRadio });
//     }
// });

// removeDuplicateSizes();

// }
//     });
// });


// //search code below
// console.log("Javascript Called Here");

//   const searchInput = document.querySelector('.header-search__input');
//   let typingTimer; // Timer identifier
//   const typingDelay = 3000; // Delay time in milliseconds (e.g., 500ms)

//   // Add keyup event listener
//   searchInput.addEventListener('keyup', () => {
//     clearTimeout(typingTimer); // Clear the timer if the user is still typing
//     typingTimer = setTimeout(() => {
//       console.log('hello'); // Log "hello" when the user stops typing
//        hideAltliWithoutHiddenInput();
//        removeDuplicateSizes();

//      document.querySelectorAll('.product-group-variants').forEach((productGroup) => {
//      const colorRadios = productGroup.querySelectorAll('.product-grid-options-color input[type="radio"]');
//      colorRadios.forEach((radio) => {
//         radio.addEventListener('change', updateSelectedSize);
//     });
// });

// // Initial state update for all .product-group-variants
//    document.querySelectorAll('.product-group-variants').forEach((productGroup) => {
//     const selectedRadio = productGroup.querySelector('.product-grid-options-color input[type="radio"]:checked');
//     if (selectedRadio) {
//         updateSelectedSize({ target: selectedRadio });
//     }
// });

//  document.querySelectorAll('.product-grid-options-size .altli').forEach(div => {
//     // Check if the div does NOT have both "is-selected" and "ava" classes
//     if (!div.classList.contains('is-selected')) {
//       // Hide the div if it doesn't have both classes
//       div.style.display = 'none';
//     }
//   });
  
//     const parentDiv = document.querySelector('.product-group-variants');
      
//     }, typingDelay);
//   });


// Uncomplicated Icons - Show More functionality for mobile
(function() {
  let observer = null;
  let checkInterval = null;
  
  function initUncomplicatedIconsShowMore() {
    const iconsContainer = document.getElementById('uncomplicated-icons');
    if (!iconsContainer) {
      // Container doesn't exist yet, try again later
      return;
    }
    
    // Check if we're on mobile (screen width <= 749px)
    function isMobile() {
      return window.innerWidth <= 749;
    }
    
    // Get all icon items (count all items, not just visible ones, since they may be hidden by CSS)
    function getAllItems() {
      return Array.from(iconsContainer.querySelectorAll('.subcat-grid-item'));
    }
    
    // Get visible items - count all items that exist (the app will handle showing/hiding them)
    function getVisibleItems() {
      const allItems = getAllItems();
      // Count all items - the app's JavaScript will handle which ones are actually shown
      // We just need to know how many items exist to determine if we need the button
      return allItems.filter(item => {
        // Only exclude items that are clearly not meant to be shown
        // Items might start as subcat-hidden but become subcat-shown later
        // So we count all items and let the app handle visibility
        return true;
      });
    }
    
    // Create or get the show more button
    function getOrCreateButton() {
      let button = document.getElementById('uncomplicated-icons-show-more');
      if (!button) {
        button = document.createElement('button');
        button.id = 'uncomplicated-icons-show-more';
        button.textContent = 'Show More';
        button.setAttribute('aria-label', 'Show more categories');
        // Insert after the container
        if (iconsContainer.nextSibling) {
          iconsContainer.parentNode.insertBefore(button, iconsContainer.nextSibling);
        } else {
          iconsContainer.parentNode.appendChild(button);
        }
        
        button.addEventListener('click', function() {
          const isExpanded = iconsContainer.classList.contains('expanded');
          if (isExpanded) {
            iconsContainer.classList.remove('expanded');
            button.textContent = 'Show More';
          } else {
            iconsContainer.classList.add('expanded');
            button.textContent = 'Show Less';
          }
        });
      }
      return button;
    }
    
    // Update button visibility and item classes
    function updateButtonVisibility() {
      if (!isMobile()) {
        const button = document.getElementById('uncomplicated-icons-show-more');
        if (button) {
          button.classList.remove('visible');
        }
        iconsContainer.classList.remove('expanded');
        // Remove mobile-hide class from all items on desktop
        getAllItems().forEach(item => {
          item.classList.remove('mobile-hide-after-6');
        });
        return;
      }
      
      const visibleItems = getVisibleItems();
      const allItems = getAllItems();
      const button = getOrCreateButton();
      
      // Add/remove classes to items beyond the 6th visible item
      // We need to track which visible items are beyond the 6th
      let visibleIndex = 0;
      allItems.forEach((item) => {
        // Only process items that will be visible (not permanently hidden by app)
        const isPermanentlyHidden = item.classList.contains('subcat-hidden') && !item.classList.contains('subcat-shown');
        
        if (!isPermanentlyHidden) {
          if (visibleIndex >= 6) {
            item.classList.add('mobile-hide-after-6');
          } else {
            item.classList.remove('mobile-hide-after-6');
          }
          visibleIndex++;
        } else {
          item.classList.remove('mobile-hide-after-6');
        }
      });
      
      // Show button if there are more than 6 items
      // Also show it if we have at least 7 items total (to account for items that might be loading)
      if (visibleItems.length > 6 || allItems.length >= 7) {
        button.classList.add('visible');
      } else {
        button.classList.remove('visible');
        iconsContainer.classList.remove('expanded');
      }
      
      // Debug: log to console (can be removed later)
      if (window.innerWidth <= 749) {
        console.log('Uncomplicated Icons - Mobile view:', {
          totalItems: allItems.length,
          visibleItems: visibleItems.length,
          buttonVisible: button.classList.contains('visible')
        });
      }
    }
    
    // Set up MutationObserver if not already set up
    if (!observer) {
      observer = new MutationObserver(function(mutations) {
        let shouldUpdate = false;
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0 || 
              (mutation.type === 'attributes' && 
               (mutation.attributeName === 'class' || mutation.attributeName === 'style'))) {
            shouldUpdate = true;
          }
        });
        
        if (shouldUpdate) {
          // Debounce the update
          clearTimeout(updateButtonVisibility.timeout);
          updateButtonVisibility.timeout = setTimeout(updateButtonVisibility, 500);
        }
      });
      
      // Start observing
      observer.observe(iconsContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
    
    // Initial check
    updateButtonVisibility();
    
    // Check on window resize
    if (!window.uncomplicatedIconsResizeHandler) {
      let resizeTimeout;
      window.uncomplicatedIconsResizeHandler = function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateButtonVisibility, 250);
      };
      window.addEventListener('resize', window.uncomplicatedIconsResizeHandler);
    }
    
    // Set up periodic check if not already set up
    if (!checkInterval) {
      checkInterval = setInterval(updateButtonVisibility, 1500);
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUncomplicatedIconsShowMore);
  } else {
    initUncomplicatedIconsShowMore();
  }
  
  // Also try after delays to catch dynamically loaded content
  setTimeout(initUncomplicatedIconsShowMore, 500);
  setTimeout(initUncomplicatedIconsShowMore, 1500);
  setTimeout(initUncomplicatedIconsShowMore, 3000);
  setTimeout(initUncomplicatedIconsShowMore, 5000);
  setTimeout(initUncomplicatedIconsShowMore, 8000);
})();
        